import {
  BicycleIcon,
  BusIcon,
  CaravanIcon,
  CarIcon,
  CarRoofBoxIcon,
  CarTrailerIcon,
  FootPassengerIcon,
  MotorcycleIcon,
  MotorcycleSidecarIcon,
  NoIcon,
} from '@dfds-frontend/navigator-icons/icons'

interface Props {
  code: string | undefined
  height?: string
  size?: string
}

export const VehicleIcon: React.FC<Props> = ({ code, size = 'md' }) => {
  if (!code) return null

  const svgProps = { size }
  return (
    <>
      {code === 'NCAR' ? <FootPassengerIcon {...svgProps} /> : null}
      {code === 'TWOWHEELS' ? <MotorcycleIcon {...svgProps} /> : null}
      {['LARGEVEHICLE', 'MIBUS', 'MINBUS', 'BUS'].includes(code) ? <BusIcon {...svgProps} /> : null}
      {code === 'CAR' ? <CarIcon {...svgProps} /> : null}
      {['BIKV'].includes(code) ? <BicycleIcon {...svgProps} /> : null}
      {['MOC'].includes(code) ? <MotorcycleIcon {...svgProps} /> : null}
      {code === 'MOCS' ? <MotorcycleSidecarIcon {...svgProps} /> : null}
      {['CARB', 'CARH'].includes(code) ? <CarIcon {...svgProps} /> : null}
      {['CARLW', 'CARS'].includes(code) ? <CarIcon {...svgProps} /> : null}
      {code === 'CARZ' ? <CarRoofBoxIcon {...svgProps} /> : null}
      {['CARX', 'PVANB', 'PVANM'].includes(code) ? <CarIcon {...svgProps} /> : null}
      {['MCVB', 'MCVM', 'MCVS', 'MCVX'].includes(code) ? <CarIcon {...svgProps} /> : null}
    </>
  )
}

export const TrailerIcon: React.FC<Props> = ({ code, size = 'md' }) => {
  const svgProps = { size }

  if (!code) return <NoIcon {...svgProps} />

  return (
    <>
      {['TRAB', 'TRAS', 'TRAX', 'TRAZ'].includes(code) ? <CarTrailerIcon {...svgProps} /> : null}
      {['CAMB', 'CAMS'].includes(code) ? <CaravanIcon {...svgProps} /> : null}
    </>
  )
}
